import { lsgetItem } from "./localStorageHelper";
import { getKey } from "./UrlHelper";

export function authHeader(headers) {
  // return authorization header with jwt token
  let user = lsgetItem('user');
  let eventId = null;
  let languageCode = null;
  if (window.location.search) {
    const params = new URLSearchParams(window.location.search);
    let unparsedEventId = params.get(getKey("eventId", params));
    if (unparsedEventId) eventId = parseInt(unparsedEventId)
    languageCode = params.get(getKey("languageCode", params));
  }
  if (user && !eventId) {
    eventId = user.eid === undefined ? user.token.eid : user.eid;
  }
  if (user && !languageCode) {
    languageCode = user.userLang === undefined ? user.token.userLang : user.userLang;
  }
  if (!languageCode) languageCode = "swe";
  if (user && user.token) {
    return { ...headers, Authorization: "Bearer " + user.token.toString(), eid: eventId, userLang: languageCode };
  } else {
    return { ...headers, eid: eventId, userLang: languageCode };
  }
}


